import { Brand, WithContext } from "schema-dts";

import { BrandDetail } from "@/custom-types/BrandDetail";

function generateBrandSchema(
  brand: BrandDetail,
  domain: string,
  includeContext: false,
): Brand;
function generateBrandSchema(
  brand: BrandDetail,
  domain: string,
  includeContext?: true,
): WithContext<Brand>;
function generateBrandSchema(
  brand: BrandDetail,
  domain: string,
  includeContext = true,
): Brand | WithContext<Brand> {
  const isDefaultPlaceholder = brand.logo.includes("brand-placeholder");

  return {
    ...(includeContext && { "@context": "https://schema.org" }),
    "@type": "Brand",
    name: brand.name,
    url: `${domain}/brands/${brand.slug}`,
    ...(brand.description && { description: brand.description }),
    ...(brand.photos[0]?.imageUrl && { image: brand.photos[0].imageUrl }),
    ...(brand.tagline && { slogan: brand.tagline }),
    ...(!isDefaultPlaceholder && { logo: brand.logo }),
  };
}

export default generateBrandSchema;
